import axios from 'axios';

export default {
    namespaced: true,
    state: {
        listings: null,
        loading: false
    },
    getters: {
        activeListingCount(state) {
            return state.listings ? state.listings.length : null;
        }
    },
    mutations: {
        resetListingDetail(state) {
            state.listings = null;
        },
        startLoading(state) {
            state.loading = true;
        },
        updateActiveListings(state, data) {
            state.listings = data;
            state.loading = false;
        }
    },
    actions: {
        getActiveListings({ commit }) {
            commit('resetListingDetail');
            commit('startLoading');
            axios
                .get('/active-listings')
                .then(result => {
                    commit('updateActiveListings', result.data.data);
                })
                .catch(console.error);
        },
        deactivateListing(context, listing_id) {
            axios.put('/deactivate-listing/' + listing_id).catch(console.error);
        },
        reactivateListing(context, listing_id) {
            axios.put('/reactivate-listing/' + listing_id).catch(console.error);
        },
        deleteListing(context, listing_id) {
            axios.put('/delete-listing/' + listing_id).catch(console.error);
        },
        addView(context, listing_id) {
            axios.put('/add-view/' + listing_id).catch(console.error);
        }
    }
};
